/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable @sailor/base-prefer-array-destructuring */
import React, { useState } from 'react'
import styles from './index.module.less'
import { Button, Divider, Radio, Upload, Icon } from '@roo/roo'
import { useTranslation } from '@sailor/i18n-web'
import { createPolling, downloadFile } from '@/common/utils'
import DetailPageWraper from '@/components/DetailPageWraper'
import { useNavigate } from 'react-router-dom'
import {
  getStaffTplt,
  batchUploadStaff,
  getStaffUploadStatus,
  initAllStaffExport,
  queryExportStatus,
} from '@/pages/staff/common/api'
import { debounce } from 'lodash-es'
import { failToast, successToast } from '@/common/utils/toast'

const RadioGroup = Radio.Group
const OPS_TYPE_ENUM = {
  ADD: '1',
  UPDATE: '2',
}
// eslint-disable-next-line max-len
const EXCEL_ICON = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAA8CAMAAADrC+IEAAABPlBMVEUAAACZmZmampqampoRe0Aujl4RfEIfpGUZXDebm5ubm5uampqampoaXDYSfEEgo2QgpWUaXDY0xIE0xIASfUKkpKSXtKUgo2UaXDY0xIEgpGUZXDcaXDcgpGUaWzeampogpGQaWzYgo2QZXDYgpGQaWzYgpGUfo2UaXDc1xIEfpGUaWzeZmZkhpGYaWzcgpWUbYDoho2kaXDs2xYUUfkQjqmocXDmenp4SfUI0xIASfUE1xIESfUKampo1w4ASfEE1xIA1xIASfUI1xYI3xYMSgEI1xYUVgEUQe0CZmZn///8fo2QZWzYRfEE0w4AlhlH0+fZAlWbt9fH8/fzT59zD3s/A3M2z1cJ7tpV0spA5kWAvjFkagUe62ciQwaZwsI1nq4ZjqYJEmGkti1fh7ufa6uHN49ehy7Rgp4BRn3QW0Ds5AAAASHRSTlMAgJ2k5gWI5plmLnj55puZc3PmmXAOBfj49fHx5NfXzMbGt7egoJiLi3NqalpGRjAwJyclJSQkHfHX18bGv7e3n4uLakZGMDCbe2qxAAACI0lEQVRIx+XX51LbQBQF4OtYci9gY3rvoXfSe5EWHFAghOKQQPr7v0COrB83i1hzd5IZmOH88c5Yn+6xJMsy/afksglj5jbNrpb0W6WQN0qGhtwxVcV7SVPXljQLSKaEzEix30QrSUxtJVNbydRWMrWVTG0lU3vJVC4Lvt9JTPNyOYSt/6KFTbHM+3rmxJIe6zIhl5QfKkilOYlrk27K8S6Lk3KvkCnPlNQV0jFKh9BoZrJcnlok5M3zarX6spOlZw4RjW+F6VomWu15F+aZVPbCIW1Ed8GQnotyJwiCRnN1HATHLIcjOU/0KpIPY/K9Uj895FwpdcRyfTSdTg9gJIber1QqT1Zjbc8gzj2vvq/UAbc1hGWYj0rt171DpXa/iiX3PdzZVeqzZyWRXxh3wF1FkvuGXTXpdpRKpRdvCVmcKpcnZ1xdct+oK8tSvZk1ouWurTDjcYl8UmrvRJf3ItlB1AaG9F4mzxTyQZePIvmaaD6Swyy1ssiRJteeOo7zACMxdAAXxei6JvmEhqfzxPbYfsGHDOo/0Fcsuesprvc99BVKPq7fGng95b4yia7qt4c0vqMvS3c2k8lMLxGyNI3lrCv9Zk9sh+leIVrpbi4npLJvu5l2ovZo1SeVI9H2C0QL0WpEeu/bGOsvFgcxEkMHi8X+sQ2r+639Pf4G/iLdPhl7Mm712J6NP40LAujnLuxKmFi5WlIMazb/dDjZHP1T/gBCPWmLKsNLHwAAAABJRU5ErkJggg=='

export default () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [operationType, setOperationType] = useState<string>(OPS_TYPE_ENUM.ADD)
  const [batchUploading, setBatchUploading] = useState<boolean>(false)
  const [downloadTpltLoading, setDownloadTpltLoading] = useState<boolean>(false)
  const [fileCache, setFailCache] = useState<File>()
  const [pollingResult, setPollingResult] = useState<{
    code: number;
    message: string;
    successCount?: number;
    errorCount?: number;
    downLoadUrl?: string;
  }>()

  const handleChange = async (options: any) => {
    const file = options.file as File
    setFailCache(file)
  }

  const handleUpload = async () => {
    if (!fileCache || batchUploading) {
      return
    }
    setBatchUploading(true)
    const initRes = await batchUploadStaff({
      byteBuffer: fileCache,
      operationType,
    })
    const { success, data: token } = initRes
    if (success && token) {
      setPollingResult(undefined)
      createPolling({
        requestFunction: () => getStaffUploadStatus({ token }),
        checkSuccess: (response) => response.data.code === 30,
        onSuccess: (response) => {
          const { data } = response
          successToast(t('e_pc_operation_success'))
          setPollingResult(data)
          setBatchUploading(false)
        },
        checkError: (response) => response?.success === false || response?.data?.code === 40,
        onError: (error) => {
          if (error?.success && error.data.code === 40) {
            failToast(error.data.message)
          }
          setBatchUploading(false)
        },
      })
    } else {
      setBatchUploading(false)
    }
  }

  const debounceHandleUpload = debounce(handleUpload, 300)

  const handleDownloadTplt = async () => {
    if (downloadTpltLoading) {
      return
    }
    setDownloadTpltLoading(true)
    if (operationType === OPS_TYPE_ENUM.ADD) {
      const res = await getStaffTplt()
      const { success, data: url } = res
      if (success && url) {
        const fileName = url.split('/').pop() || ''
        downloadFile({
          url,
          fileName,
        })
      }
      setDownloadTpltLoading(false)
    } else {
      const initRes = await initAllStaffExport()
      const { success, data: token } = initRes
      if (success && token) {
        createPolling({
          requestFunction: async () => queryExportStatus({ token }),
          checkSuccess: (response) => response.data.code === 30,
          onSuccess: (response) => {
            const { downLoadUrl } = response.data || {}
            const regex = /\/([^?#]+\.xlsx)(?:\?|#|$)/i
            // 使用正则表达式匹配
            const match = downLoadUrl.match(regex)
            const fileName = match[1]
            downloadFile({
              url: downLoadUrl,
              fileName,
            })
            setDownloadTpltLoading(false)
          },
          checkError: (response) => response?.success === false || response?.data?.code === 40,
          onError: (error) => {
            if (error?.success && error.data.code === 40) {
              failToast(error.data.message)
            }
            setDownloadTpltLoading(false)
          },
        })
      } else {
        setDownloadTpltLoading(false)
      }
    }
  }

  const debounceDownloadTplt = debounce(handleDownloadTplt, 300)

  const resultRenderer = () => {
    if (!pollingResult) {
      return null
    }
    const { errorCount, successCount } = pollingResult
    return <>
      <span>{t('e_pccompleted_operations_for_successcount_employees', { successCount: successCount ?? 0 })}</span>
      {errorCount ? <span>{`, ${t('e_pcthere_are_errrcount_entries_that_do_not_meet_the_filling_standards', { errorCount })}`}</span> : null}
    </>
  }

  const handleDownlaodFailReport = () => {
    if (!pollingResult) {
      return
    }
    const { downLoadUrl } = pollingResult
    if (!downLoadUrl) {
      return
    }
    const regex = /\/([^?#]+\.xlsx)(?:\?|#|$)/i
    // 使用正则表达式匹配
    const match = downLoadUrl.match(regex)
    const fileName = match?.[1] || ''
    downloadFile({
      url: downLoadUrl,
      fileName,
    })
  }

  return (
    <DetailPageWraper
      title={t('staff_batch_management_of_employees', '批量管理員工')}
      parentTitle={t('e_pc_enterprise_mgmt', '企业管理')}
      onParentClick={() => navigate('/enterprise?tab=staff')}
      loading={false}
    >
      <h1>{t('staff_batch_management_of_employees', '批量管理員工')}</h1>
      <h2>{t('staff_import_data', '导入数据')}</h2>
      <Divider />
      <div className={styles.contentWrapper}>
        <div className={styles.blockWrapper}>
          <span className={styles.actionItem}>
            <b>{t('staff_upload_files', '上传文件')}</b>
          </span>
          <Button
            className={styles.buttonItem}
            type="hollow"
            shape="round"
            loading={downloadTpltLoading}
            onClick={debounceDownloadTplt}
          >
            {t('staff_download_template', '下载模板')}
          </Button>
          <Upload customRequest={handleChange} listType="text" accept=".xlsx">
            <Button className={styles.buttonItem} type="hollow" shape="round">
              {t('staff_upload_files', '上传文件')}
            </Button>
          </Upload>
          <Button
            className={styles.buttonItem}
            type="brand"
            shape="round"
            loading={batchUploading}
            onClick={debounceHandleUpload}
            disabled={!fileCache}
          >
            {t('staff_submit', '提交')}
          </Button>
        </div>
        {fileCache ? (
          <div className={`${styles.blockWrapper} ${styles.actionResultItem}`}>
            <img className={styles.icon} src={EXCEL_ICON} />
            <div className={styles.fileText}>{fileCache.name}</div>
            <Icon
              name="trash-o"
              onClick={() => {
                setFailCache(undefined)
              }}
            />
          </div>
        ) : null}
        <div className={styles.blockWrapper}>
          <span className={styles.actionItem}>
            <b>{t('staff_operation_type', '操作类型')}</b>
          </span>
          <span>
            <RadioGroup value={operationType} onChange={setOperationType}>
              <div>
                <Radio value={OPS_TYPE_ENUM.ADD} type="brand">
                  <div className={styles.radioText}>
                    {t('staff_batch_add_employees', '批量新增员工')}
                  </div>
                </Radio>
              </div>
              <div style={{ marginTop: '8px' }}>
                <Radio value={OPS_TYPE_ENUM.UPDATE} type="brand">
                  <div className={styles.radioText}>
                    {t('staff_batch_modify_employee_information', '批量修改员工信息')}
                  </div>
                </Radio>
              </div>
            </RadioGroup>
          </span>
        </div>
      </div>
      <h2>{t('staff_import_results', '导入结果')}</h2>
      <Divider />
      <div className={styles.contentWrapper}>
        <div className={styles.blockWrapper}>
          <span className={styles.actionItem}>
            <b>{t('e_pcresult_explanation', '结果说明')}</b>
          </span>
          {resultRenderer()}
        </div>
        <div className={styles.blockWrapper}>
          {
            pollingResult?.downLoadUrl ? (
              <Button
                className={styles.actionResultItem}
                type="brand"
                shape="round"
                onClick={handleDownlaodFailReport}
              >
                {t('e_pc_download_error_report', '下载错误报告')}
              </Button>
            ) : null
          }
        </div>
      </div>
    </DetailPageWraper>
  )
}
